import ProfileSvg from '../../../assets/icons/profile.svg?react';
import OrganizationSvg from '../../../assets/icons/organization.svg?react';
import UserManagementSvg from '../../../assets/icons/user-management.svg?react';
import { Avatar } from 'antd';
import { NavigateFunction, useNavigate } from 'react-router-dom';
import { sideBarIconSize } from '../../../constants/styles/mixins';
import RoutePaths from '../../../router/RoutePaths';
import ListItem from '../../UI/Components/ListItem';
import { OrganizationProps } from './OrganizationItem';
import { ApiOutlined, CheckCircleOutlined } from '@ant-design/icons';

export interface ActiveOrganizationProps extends OrganizationProps {
  isAdmin: boolean;
}

export const ActiveOrganizationItem = ({ organizationAccess, isAdmin }: ActiveOrganizationProps) => {
  const navigate = useNavigate();

  return (
    <div className="flex flex-shrink-0 flex-col items-start rounded-lg outline outline-2 outline-offset-[-2px] outline-neutral-300 p-2 gap-2 overflow-hidden">
      <div className="w-full flex items-center gap-2">
        <Avatar src={organizationAccess.organizationPicturePath} shape="square" size={32}>
          {organizationAccess?.name.substring(0, 1)}
        </Avatar>
        <div className="flex-grow min-w-0 h-9 flex-col justify-center items-start inline-flex">
          <div
            className="text-brand-grey-dark text-sm font-medium leading-tight w-full truncate"
            title={organizationAccess.name}
          >
            {organizationAccess.name}
          </div>
          <div className="text-neutral-900 text-xs font-normal leading-none">{`${organizationAccess.OrganizationAccess.length} ${organizationAccess.OrganizationAccess.length === 1 ? ' member' : ' members'}`}</div>
        </div>
        <CheckCircleOutlined className="w-4 h-4 text-brand-taskonio-green" />
      </div>

      <div className="flex flex-col items-start pl-3 gap-2">
        <ListItem
          icon={<ProfileSvg style={{ width: sideBarIconSize }} />}
          text="My Profile"
          selected={false}
          onClick={() => {
            navigate(`/${organizationAccess.publicId}/settings/my-profile`);
          }}
        />

        {isAdmin && (
          <ListItem
            icon={<OrganizationSvg style={{ width: sideBarIconSize }} />}
            text="Organization Settings"
            selected={false}
            onClick={() => {
              navigate(`/${organizationAccess.publicId}/settings/organization-settings`);
            }}
          />
        )}

        {/* Same icon, label, position and admin gate as the Settings sidebar
            (SettingsWrapper.tsx): connecting an installation binds an external
            account to the whole organization, so it is admin-only there too. */}
        {isAdmin && (
          <ListItem
            icon={<ApiOutlined style={{ width: sideBarIconSize }} />}
            text="Integrations"
            selected={false}
            onClick={() => {
              navigate(`/${organizationAccess.publicId}/settings/integrations`);
            }}
          />
        )}

        <ListItem
          icon={<UserManagementSvg style={{ width: sideBarIconSize }} />}
          text="User Management"
          selected={false}
          onClick={() => {
            navigate(`/${organizationAccess.publicId}/settings/user-management`);
          }}
        />
      </div>
    </div>
  );
};
